/**
 * @file 号码类型反馈
 * @author hukeke01
 */
import React from 'react';
import Checkbox from 'antd/lib/checkbox';
import LabelFormItem from '../../components/LabelFormItem/index';
import {
    ExclamationCircleOutlined
} from '@ant-design/icons';

export interface IData {
    business_email?: {name: string; add: string;}[];
    website?: string;
    customer?: {name: string; url: string;}[];
    wechat?: {qrcodeUrl: string; name: string; id: string;}[];
    microblog?: {name: string; link: string; qrcodeUrl: string;}[];
}
interface INoNumFeedbackProps {
    noNumChangeCallback: (val: string) => void;
    datatype: '1' | '2';
    noNumObj: {
        noNumValueErr: string;
    };
    data: IData;
}
export default function NoNumFeedback(props: INoNumFeedbackProps) {
    const {noNumChangeCallback, datatype, noNumObj, data} = props;

    const createCheckItem = () => {
        const {website, business_email, customer, wechat, microblog} = data;
        const tempArr: any = [];
        if (datatype === '1') {
            if (website) {
                const tempObj = {
                    value: 'website',
                    name: '官方网站',
                    subName: website
                };
                tempArr.push(tempObj);
            }
            if (business_email && business_email.length > 0) {
                business_email.map((item, key) => {
                    const tempObj = {
                        value: 'business_email-' + key,
                        name: item.name,
                        subName: item.add
                    };
                    tempArr.push(tempObj);
                });
            }
            if (customer && customer.length > 0) {
                customer.map((item ,key) => {
                    const tempObj = {
                        value: 'customer-' + key,
                        name: '在线客服',
                        subName: item.name
                    };
                    tempArr.push(tempObj);
                });
            }
            if (wechat && wechat.length > 0) {
                wechat.map((item,key) => {
                    const tempObj = {
                        value: 'wechat-' + key,
                        name: '微信',
                        subName: item.name + ' ' + item.id
                    };
                    tempArr.push(tempObj);
                });
            }
            if (microblog && microblog.length > 0) {
                microblog.map((item,key) => {
                    const tempObj = {
                        value:'microblog-' + key,
                        name: '微博',
                        subName: item.name
                    };
                    tempArr.push(tempObj);
                });
            }
        }

        tempArr.push({
            value: 'other',
            name: '我有准确信息'
        });
        return tempArr;
    };
    const checkList = createCheckItem();
    const formatCheckValue = (value: Array<string>) => {
        const tempObj: any = {};
        value.forEach((item) => {
            if (item === 'website') {
                tempObj.website = data.website;
            } else if (item === 'other') {
                tempObj.other = '1';
            } else {
                const checkItem = item.split('-');
                const itemName = checkItem[0];
                const itemValue = checkItem[1];
                if (tempObj[itemName] && tempObj[itemName].length > 0) {
                    tempObj[itemName].push(data[itemName][itemValue]);
                } else {
                    tempObj[itemName] = [data[itemName][itemValue]];
                }
            }

        });
        noNumChangeCallback(tempObj);
    };
    const onChange = (e) => {
        formatCheckValue(e);
    };
    return (<div className="no-num-feedback">
        <LabelFormItem isMsgRequired={true} title={'问题项'} />
        <Checkbox.Group onChange={onChange}>
            {checkList.map(item => {
                return (<div className="no-num-item" key={item.value}>
                    <Checkbox value={item.value}>
                        <div>{item.name}</div>
                        {item.subName && <div>{item.subName}</div>}
                    </Checkbox>
                </div>);
            })}
        </Checkbox.Group>
        {noNumObj.noNumValueErr && <p className="form-item-feedback-err">
            <ExclamationCircleOutlined style={{marginRight: '4px'}} />
            {noNumObj.noNumValueErr}</p>}
    </div>);
}